module.exports = __webpack_public_path__ + "static/media/credit-card-payment.5c25c9cf.svg";